import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const CustomModal = ({
  children,
  isOpen,
  toggle,
  style,
  modalHeader,
  size = "",
  className,
}) => {
  return (
    <Modal
      role="dialog"
      aria-label="arr-modal"
      className={`custom-arr-modal ${size} ${className}`}
      style={style}
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <div className="arr-modal-header">
        <ModalHeader style={{ padding: 0, border: "none" }}>
          {modalHeader}
        </ModalHeader>
        <FontAwesomeIcon
          style={{ cursor: "pointer" }}
          onClick={toggle}
          fontSize={20}
          icon={faXmark}
        />
      </div>
      <ModalBody style={{ padding: 0 }}>{children}</ModalBody>
    </Modal>
  );
};

export default CustomModal;
